import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-servicewala',
  templateUrl: './servicewala.component.html',
  styleUrls: ['./servicewala.component.css']
})
export class ServicewalaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
